import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Modal from "react-modal";

import {
  FaSave,
  FaMapMarkerAlt,
  FaIndustry,
  FaUserTie,
  FaComment,
  FaFileAlt,
  FaShieldAlt,
  FaPlusCircle,
  FaList
} from "react-icons/fa";

import {
  getlugar,
  getUbicacion,
  getMaterial,
  getnorma,
  getCliente,
  postReferencia
} from "../../../redux/actions";

import styles from "./nuevaReferencia.module.css";

// Para el Modal de React-Modal
Modal.setAppElement('#root');

const CrearReferencia = () => {
  const dispatch = useDispatch();

  const lugares = useSelector(s => s.lugar);
  const ubicaciones = useSelector(s => s.ubicaciones);
  const materiales = useSelector(s => s.material);
  const normas = useSelector(s => s.norma);
  const clientes = useSelector(s => s.clientes);

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    ref: "",
    Idlugar: "",
    Idubicacion: "",
    Idmaterial: "",
    Idnorma: "",
    Idcliente: "",
    observaciones: "",
  });

  const [errors, setErrors] = useState({});

  // Estado para las referencias creadas en esta sesión
  const [createdReferences, setCreatedReferences] = useState([]);

  // Estados para el Modal de Instrucciones
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRef, setSelectedRef] = useState(null);
  const [instructionsText, setInstructionsText] = useState("");
  const [activeChecks, setActiveChecks] = useState({
    operacionesMineras: false,
    laboratorio: false,
    operacionesMarinas: false,
    preparacionMuestras: false,
    witnessTestigo: false
  });

  useEffect(() => {
    dispatch(getlugar());
    dispatch(getUbicacion());
    dispatch(getMaterial());
    dispatch(getnorma());
    dispatch(getCliente());
  }, [dispatch]);

  const validar = (name, value) => {
    if (!value.trim()) {
      return "Dato requerido";
    }

    return "";
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setForm(prev => ({ ...prev, [name]: value }));

    setErrors(prev => ({
      ...prev,
      [name]: validar(name, value)
    }));
  };

  const formularioValido = () =>
    Object.values(form).every(v => v.toString().trim()) &&
    Object.values(errors).every(e => !e);

  const handleSubmit = async () => {
    if (!formularioValido()) {
      Swal.fire({
        icon: "warning",
        title: "Registro Incompleto",
        text: "Por favor, complete todos los campos obligatorios para continuar.",
        confirmButtonColor: "#0081cf",
        background: "#0a0e14",
        color: "#f0f6fc",
      });
      return;
    }

    setLoading(true);

    const referencia = {
      ...form,
      flag: 1,
      id_log: parseInt(sessionStorage.getItem("userId"))
    };

    try {
      await dispatch(postReferencia(referencia));

      Swal.fire({
        icon: "success",
        title: "Referencia Registrada",
        text: "La nueva referencia ha sido creada exitosamente en el catálogo maestro.",
        timer: 2000,
        showConfirmButton: false,
        background: "#0a0e14",
        color: "#f0f6fc",
      });

      // Agregar a la tabla de referencias recién creadas
      setCreatedReferences(prev => [...prev, { ...form }]);

      setForm({
        ref: "",
        Idlugar: "",
        Idubicacion: "",
        Idmaterial: "",
        Idnorma: "",
        Idcliente: "",
        observaciones: "",
      });

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error de Sistema",
        text: error?.response?.data?.error || "Ocurrió un error inesperado al procesar el registro.",
        background: "#0a0e14",
        color: "#f0f6fc",
      });
    }

    setLoading(false);
  };

  const renderSelect = (name, data, icon, label, placeholder) => (
    <div className={styles.field}>
      <label>
        {icon} {label}
      </label>

      <div className={styles.inputWrapper}>
        <select
          name={name}
          value={form[name]}
          onChange={handleChange}
          className={errors[name] ? styles.error : ""}
        >
          <option value="" disabled>{placeholder}</option>
          <option value="">-- Seleccione una opción --</option>

          {data
            .slice()
            .sort((a, b) => a.nombre.localeCompare(b.nombre))
            .map(i => (
              <option key={i.id} value={i.id}>
                {i.nombre}
              </option>
            ))}
        </select>
      </div>

      {errors[name] && (
        <span className={styles.msg}>{errors[name]}</span>
      )}
    </div>
  );

  const openInstructionsModal = (ref) => {
    setSelectedRef(ref);
    setInstructionsText("");
    setActiveChecks({
      operacionesMineras: false,
      laboratorio: false,
      operacionesMarinas: false,
      preparacionMuestras: false,
      witnessTestigo: false
    });
    setIsModalOpen(true);
  };

  const closeInstructionsModal = () => {
    setIsModalOpen(false);
    setSelectedRef(null);
  };

  const handleCheckChange = (e) => {
    const { name, checked } = e.target;
    setActiveChecks(prev => ({ ...prev, [name]: checked }));
  };

  const handleSaveInstructions = () => {
    // Aquí iría la lógica para guardar en backend
    console.log("Guardando instrucciones para:", selectedRef.ref);
    console.log("Checks:", activeChecks);
    console.log("Texto:", instructionsText);

    Swal.fire({
      icon: "success",
      title: "Instrucciones Guardadas",
      text: "Las instrucciones se han guardado correctamente (Simulación Front).",
      timer: 2000,
      showConfirmButton: false,
      background: "#0a0e14",
      color: "#f0f6fc",
    });

    closeInstructionsModal();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerSection}>
        <h2 className={styles.title}>
          <FaPlusCircle /> Registro Maestro de Referencias
        </h2>
      </div>

      <div className={styles.card}>
        <section className={styles.grid}>
          {/* Identificador de Referencia */}
          <div className={styles.field}>
            <label>
              <FaFileAlt /> Identificador Referencia
            </label>
            <input
              name="ref"
              placeholder="Ej: REF-XXXXXXX"
              value={form.ref}
              onChange={handleChange}
              className={errors.ref ? styles.error : ""}
            />
            {errors.ref && <span className={styles.msg}>{errors.ref}</span>}
          </div>

          {renderSelect("Idlugar", lugares, <FaMapMarkerAlt />, "Lugar de Operación", "Seleccionar lugar...")}
          {renderSelect("Idubicacion", ubicaciones, <FaMapMarkerAlt />, "Ubicación Geográfica", "Seleccionar ubicación...")}
          {renderSelect("Idmaterial", materiales, <FaIndustry />, "Categoría Material", "Seleccionar material...")}
          {renderSelect("Idnorma", normas, <FaShieldAlt />, "Normativa Aplicable", "Seleccionar norma...")}
          {renderSelect("Idcliente", clientes, <FaUserTie />, "Cliente Asociado", "Seleccionar cliente...")}

          {/* Observaciones */}
          <div className={`${styles.field} ${styles.full}`}>
            <label>
              <FaComment /> Detalles y Observaciones
            </label>
            <textarea
              name="observaciones"
              placeholder="Agregue información relevante o notas técnicas aquí..."
              value={form.observaciones}
              onChange={handleChange}
            />
          </div>
        </section>

        <button
          className={styles.button}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <>Guardando en Sistema...</>
          ) : (
            <>
              <FaSave /> Confirmar y Guardar Registro
            </>
          )}
        </button>
      </div>

      {/* Tabla de Referencias Creadas */}
      {createdReferences.length > 0 && (
        <div className={styles.tableContainer}>
          <h3 className={styles.tableTitle}>
            <FaList /> Referencias Creadas Recientemente
          </h3>
          <table className={styles.styledTable}>
            <thead>
              <tr>
                <th>Referencia</th>
                <th>Observaciones</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {createdReferences.map((ref, index) => (
                <tr key={index}>
                  <td>{ref.ref}</td>
                  <td>{ref.observaciones || "Sin observaciones"}</td>
                  <td>
                    <button
                      className={styles.actionButton}
                      onClick={() => openInstructionsModal(ref)}
                    >
                      Crear Instrucciones
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal para Crear Instrucciones */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeInstructionsModal}
        className={styles.modalContent}
        overlayClassName={styles.modalOverlay}
      >
        <h2 className={styles.modalTitle}>
          Crear Instrucciones para: {selectedRef?.ref}
        </h2>
        
        <div className={styles.instructionOptions}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="operacionesMineras"
              checked={activeChecks.operacionesMineras}
              onChange={handleCheckChange}
            />
            Operaciones Mineras
          </label>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="laboratorio"
              checked={activeChecks.laboratorio}
              onChange={handleCheckChange}
            />
            Laboratorio
          </label>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="operacionesMarinas"
              checked={activeChecks.operacionesMarinas}
              onChange={handleCheckChange}
            />
            Operaciones Marinas
          </label>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="preparacionMuestras"
              checked={activeChecks.preparacionMuestras}
              onChange={handleCheckChange}
            />
            Preparación de muestras
          </label>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="witnessTestigo"
              checked={activeChecks.witnessTestigo}
              onChange={handleCheckChange}
            />
            Witness / testigo
          </label>
        </div>

        <div className={styles.quillContainer}>
          <ReactQuill
            theme="snow"
            value={instructionsText}
            onChange={setInstructionsText}
            placeholder="Escriba las instrucciones detalladas aquí..."
          />
        </div>

        <div className={styles.modalActions}>
          <button className={styles.cancelButton} onClick={closeInstructionsModal}>
            Cancelar
          </button>
          <button className={styles.saveButton} onClick={handleSaveInstructions}>
            Guardar Instrucciones
          </button>
        </div>
      </Modal>

    </div>
  );
};

export default CrearReferencia;
